import { useState, useEffect } from "react";

import Select, { components, DropdownIndicatorProps } from "react-select";
import ProductImagePicker from "./ProductImagePicker.tsx";
import logo from "../../assets/images/background.png";
import { translateToReactSelect } from "utils/KHelperFunctions";
import { translateToProductReactSelect } from "../../utils/helperFunctions.js";

import { connection } from "../../utils/apiConnection.ts";
import toast from "react-hot-toast";
import { debounce } from "lodash";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";

import { BsFillArrowDownSquareFill } from "react-icons/bs";
import { useParams } from "react-router-dom";
import { AiOutlineSearch } from "react-icons/ai";
export default function DefineProduct({ setUpdaterProduct }) {
  let supplierId = useParams();
  const [productList, setProductList] = useState({ data: [] });
  const [selected, setSelected] = useState({
    // label: "کالای مورد نظر را خود را جستجو کنید",
    label: "",
    value: "",
    default_price: "",
    discount: "",
    total_inventory_count: "",
    leastOrder: "",
    weightFrom: "",
    weightTo: "",
    imageSource: "",
  });
  const [selectedOption, setSelectedOption] = useState({});
  const [choseProduct, setChoseProduct] = useState(false);
  function productImageHandler(names, value) {
    setSelected((prev) => {
      return {
        ...prev,
        // imageId: 1,
        // ["imageSource"]: URL.createObjectURL(event.target.files[0])
        [names]: value,
      };
    });
  }

  function inputChangeHandler(event: Event, isNumber: boolean = false) {
    let value: string = removeCommas(event.target.value),
      name: string = event.target.name;
    try {
      if (isNumber && isNaN(value))
        throw new Error("لطفا عدد را به درستی وارد نمایید.");
      value = +value;
      let tName = name.toLowerCase();

      if (tName === "discount" && selected.default_price < value)
        throw new Error("تخفیف نمیتواند از قیمت بیشتر باشد.");
      if (tName === "default_price" && selected.discount > value)
        throw new Error("قیمت نمیتواند از تخفیف کمتر باشد.");

      if (tName === "leastorder" && selected.total_inventory_count < value)
        throw new Error("حداقل سفارش نمیتواند از موجودی بیشتر باشد.");
      if (tName === "total_inventory_count" && selected.leastOrder > value)
        throw new Error("موجودی نمیتواند از حداقل سفارش کمتر باشد.");

      if (tName === "weightfrom" && selected.weightTo < value)
        throw new Error("حداقل وزن نمیتواند از حداکثر وزن بیشتر باشد.");
      if (tName === "weightto" && value != 0 && selected.weightFrom > value)
        throw new Error("حداکثر وزن نمیتواند از حداقل وزن کمتر باشد.");

      setSelected((prev) => ({ ...prev, [name]: value }));
    } catch (ex) {
      toast.error(ex.message);
    }
    // console.log("selected is : ", selected);
  }

  function checkBoxHandler(index, event: Event | undefined) {
    if (event) {
      let price = removeCommas(event.target.value);
      if (!isNaN(price)) {
        setSelectedOption((prev) =>
          prev.map((v, i) => {
            if (i == index) return { ...v, default_price: +price };
            return v;
          })
        );
      } else {
        toast.error("لطفا عدد را به درستی وارد نمایید.");
      }
    } else {
      setSelectedOption((prev) =>
        prev.map((v, i) => {
          if (i == index) return { ...v, status: !v.status };
          return v;
        })
      );
    }
  }

  function checkBoxHandler1(index, event: Event | undefined) {
    if (event) {
      let time = event.target.value;
      if (!isNaN(time)) {
        setSelectedOption((prev) =>
          prev.map((v, i) => {
            if (i == index) return { ...v, default_need_time: +time * 60 };
            return v;
          })
        );
      } else {
        toast.error("لطفا عدد را به درستی وارد نمایید.");
      }
    } else {
      setSelectedOption((prev) =>
        prev.map((v, i) => {
          if (i == index) return { ...v, status: !v.status };
          return v;
        })
      );
    }
  }
  const [validationProduct, setValidationProduct] = useState({
    price: true,
    // weightFrom: true,
    // weightTo: true,
    productId: true,
    inventory: true,
  });
  if (selected.default_price == "0") {
    console.log("ok");
  } else {
    console.log("nok");
  }
  const validation = () => {
    let isValid = true;
    if (selected.default_price == "" || selected.default_price == "0") {
      setValidationProduct((prev) => {
        return { ...prev, price: false };
      });
      isValid = false;
    } else {
      setValidationProduct((prev) => {
        return { ...prev, price: true };
      });
    }

    if (selected.value == "") {
      setValidationProduct((prev) => {
        return { ...prev, productId: false };
      });
      isValid = false;
    } else {
      setValidationProduct((prev) => {
        return { ...prev, productId: true };
      });
    }

    // if (selected.weightFrom == "") {
    //   setValidationProduct(prev => {
    //     return { ...prev, weightFrom: false };
    //   });
    //   isValid = false;
    // } else {
    //   setValidationProduct(prev => {
    //     return { ...prev, weightFrom: true };
    //   });
    // }

    // if (selected.weightTo == "") {
    //   setValidationProduct(prev => {
    //     return { ...prev, weightTo: false };
    //   });
    //   isValid = false;
    // } else {
    //   setValidationProduct(prev => {
    //     return { ...prev, weightTo: true };
    //   });
    // }

    if (
      selected.total_inventory_count == undefined ||
      selected.total_inventory_count == ""
    ) {
      setValidationProduct((prev) => {
        return { ...prev, inventory: false };
      });
      isValid = false;
    } else {
      setValidationProduct((prev) => {
        return { ...prev, inventory: true };
      });
    }

    return isValid;
  };
  const page = (x) => {
    connection("supplier/get_product", {
      page: 1,
      count: 100,
      keyword: x,
    }).then((data) => {
      setProductList(data);
    });
  };

  const pageDebounce = debounce(page, 1000);

  useEffect(() => {
    pageDebounce("");
    // const fd = new FormData();
    // fd.append("cat_id", 3);
    // fd.append("line_id", 1);
    // fd.append("page", 1);
    // fd.append("count", 100);
  }, []);

  function submitForm() {
    document.querySelector("#defineBtn").disabled = true;
    let d = {};
    if (selected.imageSource) {
      d.img_cover_files_id = selected.imageSource;
    }
    if (selected.discount) {
      d.discount = selected.default_price - selected.discount;
    }
    if (selected.leastOrder) {
      d.leastOrder = selected.leastOrder;
    }
    connection("supplier/add_product_supplier", {
      ...d,
      product_id: selected.value,
      supplier_id: supplierId.supplier_id,
      price: selected.default_price,
      total_inventory_count: selected.total_inventory_count,
      weight_from: selected.default_weight_from,
      weight_to: selected.default_weight_to,
      selected_aoos: JSON.stringify(selectedOption),
    }).then((data) => {
      if (data.status == 1) {
        toast.success("محصول با موفقیت ایجاد شد.");
        document.querySelector("#defineBtn").disabled = false;
        setUpdaterProduct((p) => !p);
        setSelected({
          value: "",
          default_price: "",
          discount: "",
          imageSource: "",
          total_inventory_count: "",
          leastOrder: "",
          default_weight_from: "",
          default_weight_to: "",
          main_cover_file_id: "",
        });
        setChoseProduct(false);
      } else {
        toast.error("مشکلی در افزودن محصول به وجود آمد");
        document.querySelector("#defineBtn").disabled = false;
      }
    });
    // console.log("show form data: ");
    // for (var [key, value] of formData1.entries()) {
    //   console.log(key, value);
    // }
  }
  const DropdownIndicator = (props: DropdownIndicatorProps) => {
    return (
      <components.DropdownIndicator {...props}>
        <AiOutlineSearch
          style={{
            color: "#ff4734",
            fontSize: 20,
            justifyContent: "start",
            // direction: "ltr"
          }}
        />
      </components.DropdownIndicator>
    );
  };
  return (
    <div className="define-product">
      <form className="">
        <div className="mb-4" style={{ minWidth: "150px" }}>
          <p
            className={`mb-1 ${choseProduct == false ? "d-block" : "d-none"}`}
            style={{ color: "orangered", fontSize: "14px" }}
          >
            ابتدا کالای مورد نظر را انتخاب کنید
            <BsFillArrowDownSquareFill className="mx-2" />
          </p>

          {/* <div class="input-group mb-3"> */}
          {/* <input type="text" class="form-control" placeholder="Recipient's username" aria-label="Recipient's username" aria-describedby="basic-addon2"> */}
          <Select
            // aria-label="Recipient's username"
            // aria-describedby="basic-addon2"
            className="w-100"
            // placeholder={
            //   <div className="d-flex justify-content-between ">

            //   </div>
            // }
            options={translateToProductReactSelect(productList.data, false)}
            value={selected}
            onChange={(e) => {
              setSelected(e);
              // console.log("selected is : ", selected);
              setSelectedOption(() => {
                let temp = [...e.option];
                for (let i = 0; i < e.option.length; i++) {
                  temp[i] = { ...temp[i], status: false };
                }
                return temp;
              });
              setChoseProduct(true);
            }}
            onInputChange={(value) => {
              pageDebounce(value);
            }}
            classNamePrefix="select-box"
            components={{
              DropdownIndicator,
              // IndicatorSeparator: () => null
              // IndicatorsContainer: () => null
            }}
          />
          {/* <span className="input-group-text" id="basic-addon2"> */}
          {/* <AiOutlineSearch
                style={{
                  color: "#ff4734"
                }}
              /> */}
          {/* </span> */}
        </div>

        <p
          className={`text-danger fs-12 ${
            validationProduct.productId == false ? "d-block" : "d-none"
          }`}
        >
          این فیلد نمی تواند خالی باشد
        </p>
        {/* </div> */}

        <div>
          {selected && (
            <div className="d-flex justify-content-center">
              <ProductImagePicker
                className="mx-3"
                productImageHandler={productImageHandler}
                src={`http://sabadi.tatdemo.ir/${selected.image}`}
                type={true}
              />

              <span style={{ width: "20px" }}></span>
              {selected.imageSource && (
                <ProductImagePicker
                  src={URL.createObjectURL(selected.imageSource)}
                  type={false}
                />
              )}
            </div>
          )}
        </div>
        <div>
          <div className="d-flex justify-content-between pricestyle mt-5">
            <div class="w-50 form-floating mb-4 ">
              <input
                type="text"
                class="form-control df-input"
                id="product-price"
                placeholder="price"
                name="default_price"
                value={addCommas(selected.default_price)}
                onChange={(e) => {
                  inputChangeHandler(e, true);
                  // console.log("product price is : ", product.data.price);
                }}
              />
              <p
                className={`text-danger fs-12 ${
                  validationProduct.price == false ? "d-block" : "d-none"
                }`}
              >
                این فیلد نمی تواند خالی باشد
              </p>
              <label for="product-price">
                قیمت
                <span style={{ fontSize: "10px" }}>(تومان)</span>
              </label>
            </div>
            <div class="w-50 form-floating mb-4 ">
              <input
                type="text"
                class="form-control df-input"
                id="product-discount"
                placeholder="discount"
                name="discount"
                value={addCommas(selected.discount)}
                onChange={(e) => inputChangeHandler(e, true)}
              />

              <label style={{ fontSize: "11px" }} for="product-discount">
                قیمت با تخفیف
                <span style={{ fontSize: "10px" }}>(تومان)</span>
              </label>
            </div>
          </div>
          <div className="d-flex justify-content-between pricestyle">
            <div class="w-50 form-floating mb-4">
              <input
                type="text"
                class="form-control df-input"
                id="product-total_inventory_count"
                placeholder="total_inventory_count"
                name="total_inventory_count"
                value={addCommas(selected.total_inventory_count)}
                onChange={(e) => inputChangeHandler(e, true)}
              />
              <p
                className={`text-danger fs-12 ${
                  validationProduct.inventory == false ? "d-block" : "d-none"
                }`}
              >
                این فیلد نمی تواند خالی باشد
              </p>
              <label for="product-total_inventory_count">موجودی </label>
            </div>
            <div class="w-50 form-floating mb-4">
              <input
                type="text"
                class="form-control df-input"
                id="product-leastOrder"
                placeholder="leastOrder"
                name="leastOrder"
                value={addCommas(selected.leastOrder)}
                onChange={(e) => inputChangeHandler(e, true)}
              />
              <label for="product-leastOrder">حداقل سفارش</label>
            </div>
          </div>
          <div className="d-flex align-items-center pricestyle ">
            <div class="w-50 text-center form-floating mb-4">
              <input
                type="text"
                class="form-control df-input "
                id="product-weightFrom"
                placeholder="weightFrom"
                name="default_weight_from"
                value={addCommas(selected.default_weight_from)}
                onChange={(e) => inputChangeHandler(e, true)}
              />
              {/* <p
                className={`text-danger fs-12 ${
                  validationProduct.weightFrom == false ? "d-block" : "d-none"
                }`}
              >
                این فیلد نمی تواند خالی باشد
              </p> */}

              <label for="product-weightFrom">حداقل وزن (گرم)</label>
            </div>
            <div class="w-50 form-floating mb-4 ">
              <input
                type="text"
                class="form-control df-input"
                id="product-weightTo"
                placeholder="weightTo"
                name="default_weight_to"
                // defaultValue={selected.default_weight_to}
                value={addCommas(selected.default_weight_to)}
                // value={product.weightTo}
                onChange={(e) => inputChangeHandler(e, true)}
              />
              {/*
               */}
              <label for="product-weightTo" style={{ fontSize: "12px" }}>
                حداکثر وزن (گرم)
              </label>
            </div>
          </div>

          {selected.option && (
            <div className="product-options-container">
              {/* {productOptions.map((value, index) => ( */}
              {selectedOption.map((value1, index) => (
                <div
                  key={`product-option-${index}`}
                  className="product-option flex-wrap"
                >
                  <div className="d-flex">
                    <label class="switch">
                      <input
                        type="checkbox"
                        checked={value1.status}
                        key={index}
                        onChange={() =>
                          setSelectedOption((prev) => {
                            let temp = [...prev];
                            temp[index].status = !selectedOption[index].status;
                            return temp;
                          })
                        }
                      />
                      <span class="slider round"></span>
                    </label>
                    <div className="mx-3">{value1.title}</div>
                  </div>
                  {value1.status && (
                    <div className="d-flex align-items-center  mt-1">
                      <input
                        type="text"
                        className="form-control product-option-input"
                        value={addCommas(selectedOption[index].default_price)}
                        // value={value1.default_price}
                        onChange={(e) => {
                          checkBoxHandler(index, e);
                          // );
                          // console.log("selectedOption2", e.target.value);
                        }}
                      />
                      <span>تومان</span>
                      <input
                        type="text"
                        className="form-control product-option-input"
                        style={{ width: "50px" }}
                        value={selectedOption[index].default_need_time / 60}
                        onChange={(e) => checkBoxHandler1(index, e)}
                      />
                      <span>دقیقه</span>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="w-100 d-flex justify-content-end">
          <button
            type="submit"
            id="defineBtn"
            className="btn submit-btn mx-3"
            onClick={(e) => {
              e.preventDefault();
              if (validation()) {
                submitForm();
              }
            }}
          >
            ثبت
          </button>
        </div>
      </form>
    </div>
  );
}
